var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trending-up_svg__clip0_3829_9900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.209 5.854l-7.917 7.916-4.167-4.166-6.25 6.25m18.334-10h-5m5 0v5",
    stroke: "#68BB3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trending-up_svg__clip0_3829_9900"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.042 .854)",
    d: "M0 0h20v20H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIiBmaWxsPSJub25lIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM4MjlfOTkwMCkiPgo8cGF0aCBkPSJNMTkuMjA4OCA1Ljg1MzUyTDExLjI5MjIgMTMuNzcwMkw3LjEyNTQ5IDkuNjAzNTJMMC44NzU0ODggMTUuODUzNU0xOS4yMDg4IDUuODUzNTJIMTQuMjA4OE0xOS4yMDg4IDUuODUzNTJWMTAuODUzNSIgc3Ryb2tlPSIjNjhCQjNFIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8zODI5Xzk5MDAiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjA0MjIzNjMgMC44NTM1MTYpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+";
export { SvgTrendingUp as ReactComponent };